// control-data_soloinsert-public

import { getFechaObj } from "./commonUtils.js"
import { addItemEntityBase } from "./firebaseBaseDataUtils.js"

export const siteevents_entity = "site-events"
export const siteevents_area = "control-data_soloinsert-public"

export const crearEventoBase = (firebase, siteId, eventoInfo, options={}) => {
  const {fechaDate = new Date()} = options 
  const { evento, user} = eventoInfo
  const fechaObj = getFechaObj("fechaEvento", fechaDate, undefined, {timezone: "America/Mexico_City"})
  const newData = {
    evento,
    user_uid : user?.uid || null,
    user_email: user?.email || null,
    // user: user || null,
    data: eventoInfo,
    ...fechaObj,
  }
  
  return addItemEntityBase(
    firebase,
    siteId,
    siteevents_entity,
    siteevents_area,
    null,
    newData,
    { includeKey: true, logItem:false, basicLogs:false },
  )
    .then(data => {
      console.log("Evento creado en la base de datos:", data)
    })
    .catch(error => {
      console.error("Error al crear el evento en la base de datos:", error)
    })
}
